import BaseFileData from "./base-file-data.ts";

class FileData2D extends BaseFileData {

}

export default FileData2D;